import { render, staticRenderFns } from "./EditorNew.vue?vue&type=template&id=2909f0fa&"
import script from "./EditorNew.vue?vue&type=script&lang=js&"
export * from "./EditorNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports